module.exports = __webpack_public_path__ + "img/滚动组 590.35c6a281.png";